import { hot } from "react-hot-loader/root";
import React from "react";

import "./AppleMusic.scss";

class TrackListItem extends React.Component {
  constructor(props) {
    super(props);

    this.play = this.play.bind(this);
  }

  async play() {
    let index = this.props.index;
    console.log("TrackItem: willPlay: index: ", index);
    await this.props.music.player.changeToMediaAtIndex(index);
    console.log("TrackItem: didPlay");
  }

  render() {
    const { track } = this.props;

    let artworkUrl = MusicKit.formatArtworkURL(
      track.attributes.artwork,
      500,
      500
    );

    let explicit =
      track.attributes.contentRating == "explicit" ? (
        <span className="badge explicit" />
      ) : (
        ""
      );

    let artworkOrNum =
      this.props.mediaType == "playlist" ? (
        <span className="am__tracklist__track__artwork">
          <img
            className="artwork"
            src={artworkUrl}
            alt="artwork"
            style={{ background: track.attributes.artwork.bgColor }}
          />
        </span>
      ) : (
        <span className="am__tracklist__track__num">
          {this.props.index + 1}
        </span>
      );

    return (
      <li className="am__tracklist__track large " onClick={this.play}>
        {artworkOrNum}
        <span className="am__tracklist__track__info">
          <span className="column-flex">
            <span className="am__tracklist__track__name name-container">
              <span className="name">{track.attributes.name}</span>
              {explicit}
            </span>
            <span className="am__tracklist__track__sub">
              {track.attributes.artistName}
            </span>
          </span>
        </span>
      </li>
    );
  }
}

export default hot(TrackListItem);
